import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import styled, { css } from 'styled-components';
import { styles } from '../Input/Input.styles';

const Styles = css`
  .react-select__control {
    ${styles}
    color: var(--ink);
    min-height: inherit;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    border-color: ${({ error }) => error && 'var(--danger) !important'};
    box-shadow: none;
    ${({ $gray }) =>
      $gray &&
      css`
        background: var(--card-bg);
      `}
    &:hover {
      border-color: var(--line);
    }
    &.react-select__control--is-focused,
    &.react-select__control--menu-is-open {
      border-color: var(--blue);
      font-size: 14px;
      color: var(--ink);
      background-color: var(--card-bg);
    }
  }
  .react-select__placeholder {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 8px);
    color: var(--text-color-50);
  }
  .react-select__value-container {
    padding-left: 0;
    padding-right: 0;
  }
  .react-select__menu {
    box-shadow: 0 4px 16px rgba(0, 43, 92, 0.1);
    border-radius: 8px;
    border: 1px solid var(--line);
    z-index: 9;
    color: var(--ink);
    background-color: var(--card-bg);
  }

  .react-select__single-value {
    color: var(--ink);
  }

  .react-select__option {
    font-size: 14px;
    cursor: pointer;
    color: var(--ink);

    &:active {
      background: var(--gray-50);
    }
  }
  .react-select__option--is-focused {
    color: var(--ink);
    background: var(--gray-50);
  }
  .react-select__option--is-selected {
    color: var(--white);
    background: var(--blue);
  }

  .react-select__indicator,
  .react-select__dropdown-indicator,
  .css-1xc3v61-indicatorContainer {
    color: var(--text-color-50) !important;
    svg {
      width: 16px;
    }
  }

  ${({ isMulti }) =>
    isMulti &&
    css`
      .react-select__control {
        height: auto;
        min-height: 45px;
        font-size: 14px;
      }
      .react-select__option {
        position: relative;
        padding-left: 42px;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 14px;
        text-transform: uppercase;

        &:before,
        &:after {
          content: '';
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          border: 1px solid var(--blue);
          border-radius: 5px;
          width: 16px;
          height: 16px;
        }
        &:hover {
          &:before,
          &:after {
            border: 1px solid var(--blue);
          }
        }
        &:after {
          content: '\\e876';
          font-family: 'Material Icons Round';
          background: var(--blue);
          opacity: 0;
          visibility: hidden;
          transition: 0.3s linear;
          color: var(--white);
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.react-select__option--is-selected {
          background: var(--primary-50);
          color: var(--ink);
          &:after {
            opacity: 1;
            visibility: visible;
          }
          &.react-select__option--is-focused {
            background: var(--primary-50);
          }
        }
      }
      .react-select__multi-value {
        background: var(--primary-50);
        line-height: 12px;
        border-radius: 60px;
        color: var(--ink);
      }
      .react-select__multi-value__label {
        color: var(--ink);
      }
    `}
`;

export const StyledSelect = styled(Select)`
  ${Styles}
`;

export const StyledSelectAsync = styled(AsyncSelect)`
  ${Styles}
`;
